import { supabase } from "../../config/supabase";

// Update a course
const getCourseById = async (courseId) => {
    try {
        const { data, error } = await supabase.from('courses').select('*').eq('course_id', courseId).single(); 
        if (error) throw new Error(error);

         // If there are challengeIds in the course data, get the challenge titles
         let challenges = [];
         if (data.challenges && data.challenges.length > 0) {
             const { data: challengeData, error: challengeError } = await supabase
                 .from('challenges')
                 .select('challenge_id,title')
                 .in('challenge_id', data.challenges); 
 
             if (challengeError) throw new Error(challengeError);
             challenges = challengeData; // list of challenge titles
         }
 
        return { error: null, data:{...data,challenges:challenges } };
    } catch (err) {
        console.log('an error in getting course:',err);
        return { error: err, data:null };
    }
};

const getAllCourses = async (page,limit = 10) => {
    try {
        const { data, error } = await supabase.from('courses').select('*', { count: 'exact' }).range((page - 1) * limit, page * limit - 1); // Calculate range for pagination
        if (error) throw new Error(error);
        return { error: null, data };
    } catch (err) {
        console.log('an error in getting courses:',err);
        return { error: err, data:null };
    }
};

const getAllCoursesIds = async () => {
    try {
        const { data, error } = await supabase.from('courses').select('course_id,title') //.range((page - 1) * limit, page * limit - 1); // Calculate range for pagination
        if (error) throw new Error(error);
        return { error: null, data };
    } catch (err) {
        console.log('an error in getting courses:',err);
        return { error: err, data:null };
    }
};

export { getCourseById, getAllCourses, getAllCoursesIds };